import { NgFor, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogRef } from '@angular/material/dialog'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatStepperModule } from '@angular/material/stepper'
import { ToastrService } from 'ngx-toastr'
import { ProfessionService } from '../../services/profession/profession.service'
import { Profession, ProfessionDTO } from '../../models/profession.interface'
import { HttpErrorResponse } from '@angular/common/http'
import { leadertype, occupation } from '../incident-observatorio/incident-form/incident.definitions'

@Component({
    selector: 'app-profession-form',
    standalone: true,
    imports: [
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgIf,
        NgFor,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    templateUrl: './profession-form.component.html',
    styleUrl: './profession-form.component.css',
})
export class ProfessionFormComponent {
    selectedProfession: Profession | null = null
    professionId: string | null = null
    errorMsg: string[] | null = null
    leadertype = leadertype
    occupation = occupation

    constructor(
        private dialogRef: MatDialogRef<ProfessionFormComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private professionService: ProfessionService
    ) {}

    ngOnInit(): void {
        this.professionService.$professionsSelected.subscribe((profession) => {
            if (profession) {
                this.professionId = String(profession.id)
                this.selectedProfession = profession
                this.editProfessionForm.patchValue({
                    ...profession,
                })
            }
        })
    }

    editProfessionForm = this.fb.group({
        name: ['', []],
        isLeader: [false],
        leaderRole: ['', []],
        companyName: ['', []],
    })

    closeDialog() {
        this.dialogRef.close()
    }

    updateProfession() {
        const payload = this.editProfessionForm.value as ProfessionDTO
        if (this.editProfessionForm.status === 'VALID' && this.professionId) {
            if (this.editProfessionForm.pristine) {
                this.dialogRef.close()
                return
            }
            const id = Number(this.professionId)
            this.professionService
                .updateProfession(id, { ...payload, id: id })
                .subscribe({
                    next: (profession) => {
                        const msg = `El registro fue EDITADO correctamente!`
                        this.toastr.success(msg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.dialogRef.close()
                    },
                    error: ({}: HttpErrorResponse) => {
                        if (this.errorMsg) {
                            this.toastr.error(
                                'Error: ' + this.errorMsg,
                                undefined,
                                {
                                    progressBar: true,
                                    timeOut: 5000,
                                }
                            )
                        }
                    },
                })
        }
    }
}
